import { render, staticRenderFns } from "./newscenter.vue?vue&type=template&id=d2a2257e&scoped=true"
import script from "./newscenter.vue?vue&type=script&lang=js"
export * from "./newscenter.vue?vue&type=script&lang=js"
import style0 from "./newscenter.vue?vue&type=style&index=0&id=d2a2257e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a2257e",
  null
  
)

export default component.exports